import createLucideIcon from '../createLucideIcon';

const ArrowBigRight = createLucideIcon('ArrowBigRightIcon', [
  ['path', { d: 'm21 12-7-7v4H3v6h11v4z', key: '58zwfy' }],
]);

export default ArrowBigRight;
